import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  ListItemButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  Search,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  Engineering 
} from '@mui/icons-material';


// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold',
    whiteSpace: 'nowrap'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données
const adultPopulationData = {
  title: "Répartition de la population des ménages ordinaires de 18 ans ou plus par province et commune selon le sexe et milieu de résidence",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", urbain: { masculin: "854", feminin: "1 166", total: "2 020" }, rural: { masculin: "21 188", feminin: "25 394", total: "46 582" }, total: { masculin: "22 042", feminin: "26 560", total: "48 602" } },
        { name: "BUTIHINDA", urbain: { masculin: "9 290", feminin: "10 768", total: "20 058" }, rural: { masculin: "77 963", feminin: "97 435", total: "175 398" }, total: { masculin: "87 253", feminin: "108 203", total: "195 456" } },
        { name: "CANKUZO", urbain: { masculin: "4 048", feminin: "4 475", total: "8 523" }, rural: { masculin: "30 395", feminin: "34 510", total: "64 905" }, total: { masculin: "34 443", feminin: "38 985", total: "73 428" } },
        { name: "GISAGARA", urbain: { masculin: "2 087", feminin: "2 431", total: "4 518" }, rural: { masculin: "57 516", feminin: "67 217", total: "124 733" }, total: { masculin: "59 603", feminin: "69 648", total: "129 251" } },
        { name: "GISURU", urbain: { masculin: "5 961", feminin: "6 492", total: "12 453" }, rural: { masculin: "62 291", feminin: "73 378", total: "135 669" }, total: { masculin: "68 252", feminin: "79 870", total: "148 122" } },
        { name: "MUYINGA", urbain: { masculin: "19 838", feminin: "22 471", total: "42 309" }, rural: { masculin: "78 099", feminin: "97 465", total: "175 564" }, total: { masculin: "97 937", feminin: "119 936", total: "217 873" } },
        { name: "RUYIGI", urbain: { masculin: "6 674", feminin: "7 692", total: "14 366" }, rural: { masculin: "39 986", feminin: "46 488", total: "86 474" }, total: { masculin: "46 660", feminin: "54 180", total: "100 840" } }
      ],
      urbain: { masculin: "48 752", feminin: "55 495", total: "104 247" },
      rural: { masculin: "367 438", feminin: "441 887", total: "809 325" },
      total: { masculin: "416 190", feminin: "497 382", total: "913 572" }
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", urbain: { masculin: "13 522", feminin: "15 882", total: "29 404" }, rural: { masculin: "36 585", feminin: "43 439", total: "80 024" }, total: { masculin: "50 107", feminin: "59 321", total: "109 428" } },
        { name: "BUKINANYANA", urbain: { masculin: "13 742", feminin: "16 474", total: "30 216" }, rural: { masculin: "41 488", feminin: "48 387", total: "89 875" }, total: { masculin: "55 230", feminin: "64 861", total: "120 091" } },
        { name: "CIBITOKE", urbain: { masculin: "32 354", feminin: "36 053", total: "68 407" }, rural: { masculin: "23 266", feminin: "26 228", total: "49 494" }, total: { masculin: "55 620", feminin: "62 281", total: "117 901" } },
        { name: "ISARE", urbain: { masculin: "1 256", feminin: "1 642", total: "2 898" }, rural: { masculin: "30 291", feminin: "38 408", total: "68 699" }, total: { masculin: "31 547", feminin: "40 050", total: "71 597" } },
        { name: "MPANDA", urbain: { masculin: "34 493", feminin: "33 837", total: "68 330" }, rural: { masculin: "45 178", feminin: "51 266", total: "96 444" }, total: { masculin: "79 671", feminin: "85 103", total: "164 774" } },
        { name: "MUGERE", urbain: { masculin: "94 558", feminin: "93 277", total: "187 835" }, rural: { masculin: "40 345", feminin: "52 782", total: "93 127" }, total: { masculin: "134 903", feminin: "146 059", total: "280 962" } },
        { name: "MUGINA", urbain: { masculin: "8 438", feminin: "9 726", total: "18 164" }, rural: { masculin: "38 950", feminin: "44 716", total: "83 666" }, total: { masculin: "47 388", feminin: "54 442", total: "101 830" } },
        { name: "MUHUTA", urbain: { masculin: "5 792", feminin: "6 900", total: "12 692" }, rural: { masculin: "18 610", feminin: "24 015", total: "42 625" }, total: { masculin: "24 402", feminin: "30 915", total: "55 317" } },
        { name: "MUKAZA", urbain: { masculin: "52 648", feminin: "33 412", total: "86 060" }, rural: { masculin: "9 999", feminin: "9 705", total: "19 704" }, total: { masculin: "62 647", feminin: "43 117", total: "105 764" } },
        { name: "NTAHANGWA", urbain: { masculin: "243 316", feminin: "219 978", total: "463 294" }, rural: { masculin: "23 844", feminin: "26 251", total: "50 095" }, total: { masculin: "267 160", feminin: "246 229", total: "513 389" } },
        { name: "RWIBAGA", urbain: { masculin: "1 226", feminin: "1 304", total: "2 530" }, rural: { masculin: "23 310", feminin: "30 449", total: "53 759" }, total: { masculin: "24 536", feminin: "31 753", total: "56 289" } }
      ],
      urbain: { masculin: "501 345", feminin: "468 485", total: "969 830" },
      rural: { masculin: "331 866", feminin: "395 646", total: "727 512" },
      total: { masculin: "833 211", feminin: "864 131", total: "1 697 342" }
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", urbain: { masculin: "2 788", feminin: "2 972", total: "5 760" }, rural: { masculin: "36 483", feminin: "48 465", total: "84 948" }, total: { masculin: "39 271", feminin: "51 437", total: "90 708" } },
        { name: "MAKAMBA", urbain: { masculin: "15 065", feminin: "18 655", total: "33 720" }, rural: { masculin: "59 691", feminin: "74 378", total: "134 069" }, total: { masculin: "74 756", feminin: "93 033", total: "167 789" } },
        { name: "MATANA", urbain: { masculin: "3 507", feminin: "3 163", total: "6 670" }, rural: { masculin: "40 711", feminin: "50 483", total: "91 194" }, total: { masculin: "44 218", feminin: "53 646", total: "97 864" } },
        { name: "MUSONGATI", urbain: { masculin: "7 450", feminin: "8 058", total: "15 508" }, rural: { masculin: "61 288", feminin: "73 821", total: "135 109" }, total: { masculin: "68 738", feminin: "81 879", total: "150 617" } },
        { name: "NYANZA", urbain: { masculin: "25 064", feminin: "28 118", total: "53 182" }, rural: { masculin: "54 489", feminin: "63 569", total: "118 058" }, total: { masculin: "79 553", feminin: "91 687", total: "171 240" } },
        { name: "RUMONGE", urbain: { masculin: "29 212", feminin: "32 452", total: "61 664" }, rural: { masculin: "61 723", feminin: "75 909", total: "137 632" }, total: { masculin: "90 935", feminin: "108 361", total: "199 296" } },
        { name: "RUTANA", urbain: { masculin: "10 036", feminin: "10 302", total: "20 338" }, rural: { masculin: "37 524", feminin: "45 183", total: "82 707" }, total: { masculin: "47 560", feminin: "55 485", total: "103 045" } }
      ],
      urbain: { masculin: "93 122", feminin: "103 720", total: "196 842" },
      rural: { masculin: "351 909", feminin: "431 808", total: "783 717" },
      total: { masculin: "445 031", feminin: "535 528", total: "980 559" }
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", urbain: { masculin: "4 868", feminin: "5 858", total: "10 726" }, rural: { masculin: "66 340", feminin: "82 827", total: "149 167" }, total: { masculin: "71 208", feminin: "88 685", total: "159 893" } },
        { name: "KAYANZA", urbain: { masculin: "12 158", feminin: "14 360", total: "26 518" }, rural: { masculin: "59 457", feminin: "75 148", total: "134 605" }, total: { masculin: "71 615", feminin: "89 508", total: "161 123" } },
        { name: "KIREMBA", urbain: { masculin: "3 508", feminin: "4 194", total: "7 702" }, rural: { masculin: "55 387", feminin: "72 397", total: "127 784" }, total: { masculin: "58 895", feminin: "76 591", total: "135 486" } },
        { name: "KIRUNDO", urbain: { masculin: "8 660", feminin: "9 807", total: "18 467" }, rural: { masculin: "88 440", feminin: "111 423", total: "199 863" }, total: { masculin: "97 100", feminin: "121 230", total: "218 330" } },
        { name: "MATONGO", urbain: { masculin: "1 554", feminin: "2 051", total: "3 605" }, rural: { masculin: "52 346", feminin: "73 748", total: "126 094" }, total: { masculin: "53 900", feminin: "75 799", total: "129 699" } },
        { name: "MUHANGA", urbain: { masculin: "3 464", feminin: "4 714", total: "8 178" }, rural: { masculin: "41 407", feminin: "62 331", total: "103 738" }, total: { masculin: "44 871", feminin: "67 045", total: "111 916" } },
        { name: "NGOZI", urbain: { masculin: "28 733", feminin: "31 505", total: "60 238" }, rural: { masculin: "45 142", feminin: "56 114", total: "101 256" }, total: { masculin: "73 875", feminin: "87 619", total: "161 494" } },
        { name: "TANGARA", urbain: { masculin: "2 022", feminin: "2 631", total: "4 653" }, rural: { masculin: "48 835", feminin: "68 416", total: "117 251" }, total: { masculin: "50 857", feminin: "71 047", total: "121 904" } }
      ],
      urbain: { masculin: "64 967", feminin: "75 120", total: "140 087" },
      rural: { masculin: "457 354", feminin: "602 404", total: "1 059 758" },
      total: { masculin: "522 321", feminin: "677 524", total: "1 199 845" }
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", urbain: { masculin: "2 039", feminin: "3 022", total: "5 061" }, rural: { masculin: "42 142", feminin: "62 622", total: "104 764" }, total: { masculin: "44 181", feminin: "65 644", total: "109 825" } },
        { name: "GISHUBI", urbain: { masculin: "1 149", feminin: "1 734", total: "2 883" }, rural: { masculin: "36 225", feminin: "71 594", total: "107 819" }, total: { masculin: "37 374", feminin: "73 328", total: "110 702" } },
        { name: "GITEGA", urbain: { masculin: "48 676", feminin: "58 951", total: "107 627" }, rural: { masculin: "57 044", feminin: "83 757", total: "140 801" }, total: { masculin: "105 720", feminin: "142 708", total: "248 428" } },
        { name: "KARUSI", urbain: { masculin: "5 115", feminin: "6 250", total: "11 365" }, rural: { masculin: "69 179", feminin: "89 430", total: "158 609" }, total: { masculin: "74 294", feminin: "95 680", total: "169 974" } },
        { name: "KIGANDA", urbain: { masculin: "1 939", feminin: "2 412", total: "4 351" }, rural: { masculin: "27 668", feminin: "39 478", total: "67 146" }, total: { masculin: "29 607", feminin: "41 890", total: "71 497" } },
        { name: "MURAMVYA", urbain: { masculin: "6 605", feminin: "7 927", total: "14 532" }, rural: { masculin: "27 582", feminin: "38 883", total: "66 465" }, total: { masculin: "34 187", feminin: "46 810", total: "80 997" } },
        { name: "MWARO", urbain: { masculin: "2 711", feminin: "2 961", total: "5 672" }, rural: { masculin: "29 116", feminin: "39 245", total: "68 361" }, total: { masculin: "31 827", feminin: "42 206", total: "74 033" } },
        { name: "NYABIHANGA", urbain: { masculin: "1 272", feminin: "1 557", total: "2 829" }, rural: { masculin: "32 586", feminin: "49 434", total: "82 020" }, total: { masculin: "33 858", feminin: "50 991", total: "84 849" } },
        { name: "SHOMBO", urbain: { masculin: "1 394", feminin: "1 855", total: "3 249" }, rural: { masculin: "49 148", feminin: "64 783", total: "113 931" }, total: { masculin: "50 542", feminin: "66 638", total: "117 180" } }
      ],
      urbain: { masculin: "70 900", feminin: "86 669", total: "157 569" },
      rural: { masculin: "370 690", feminin: "539 226", total: "909 916" },
      total: { masculin: "441 590", feminin: "625 895", total: "1 067 485" }
    }
  ],
  total: {
    urbain: { masculin: "779 086", feminin: "789 489", total: "1 568 575" },
    rural: { masculin: "1 879 257", feminin: "2 410 971", total: "4 290 228" },
    total: { masculin: "2 658 343", feminin: "3 200 460", total: "5 858 803" }
  }
};

const AdultPopulationPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };
 // Calcul des indicateurs clés
const keyStats = {
  totalPopulation: adultPopulationData.total.total.total,
  urbanPercentage: (
    (parseFloat(adultPopulationData.total.urbain.total.replace(/\s/g, '')) / 
     parseFloat(adultPopulationData.total.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  ruralPercentage: (
    (parseFloat(adultPopulationData.total.rural.total.replace(/\s/g, '')) / 
     parseFloat(adultPopulationData.total.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  womenPercentage: (
    (parseFloat(adultPopulationData.total.total.feminin.replace(/\s/g, '')) / 
     parseFloat(adultPopulationData.total.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  mostPopulousProvince: adultPopulationData.provinces.reduce((max, province) => 
    parseFloat(province.total.total.replace(/\s/g, '')) > parseFloat(max.total.total.replace(/\s/g, '')) ? province : max
  ),
  highestGenderGap: adultPopulationData.provinces.reduce((max, province) => {
    const gap = Math.abs(
      parseFloat(province.total.masculin.replace(/\s/g, '')) - 
      parseFloat(province.total.feminin.replace(/\s/g, ''))
    );
    return gap > max.gap ? { province, gap } : max;
  }, { province: null, gap: 0 })
};

  const filteredProvinces = adultPopulationData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);
// Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
   <MainContainer>
        <CssBaseline />
        <NavigationBar />
        <MainContentWithDrawer>
          {!isMobile ? (
            <DrawerWrapper>
              {drawer}
            </DrawerWrapper>
          ) : (
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
              }}
            >
              {drawer}
            </Drawer>
          )}
  
          <ContentWrapper>
            <Container maxWidth="lg">
              {isMobile && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                  <Button 
                    variant="outlined" 
                    startIcon={<MenuIcon />} 
                    onClick={handleDrawerToggle}
                    sx={{ color: primaryColor, borderColor: primaryColor }}
                  >
                    Menu
                  </Button>
                </Box>
              )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {adultPopulationData.title}
                    </Typography>
                  </Box>
                   <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                     <Grid item xs={12} sm={6} md={6} ></Grid>
                      <Grid item xs={12} sm={6} md={6}>
                  <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                   {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {adultPopulationData.total.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Adultes (18+ ans)
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Femmes
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.womenPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.urbanPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                {adultPopulationData.total.urbain.total} personnes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus peuplée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulousProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulousProvince.total.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((parseFloat(keyStats.mostPopulousProvince.total.total.replace(/\s/g, '')) / parseFloat(adultPopulationData.total.total.total.replace(/\s/g, '')) * 100).toFixed(1))}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell rowSpan={2}>Province/Commune</TableCell>
                          <TableCell align="center" colSpan={3}>Urbain</TableCell>
                          <TableCell align="center" colSpan={3}>Rural</TableCell>
                          <TableCell align="center" colSpan={3}>Total</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>BURUNDI</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.urbain.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.urbain.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.urbain.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.rural.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.rural.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.rural.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{adultPopulationData.total.total.total}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.urbain.masculin}</TableCell>
                              <TableCell align="right">{province.urbain.feminin}</TableCell>
                              <TableCell align="right">{province.urbain.total}</TableCell>
                              <TableCell align="right">{province.rural.masculin}</TableCell>
                              <TableCell align="right">{province.rural.feminin}</TableCell>
                              <TableCell align="right">{province.rural.total}</TableCell>
                              <TableCell align="right">{province.total.masculin}</TableCell>
                              <TableCell align="right">{province.total.feminin}</TableCell>
                              <TableCell align="right">{province.total.total}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={10}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.urbain.masculin}</TableCell>
                                          <TableCell align="right">{commune.urbain.feminin}</TableCell>
                                          <TableCell align="right">{commune.urbain.total}</TableCell>
                                          <TableCell align="right">{commune.rural.masculin}</TableCell>
                                          <TableCell align="right">{commune.rural.feminin}</TableCell>
                                          <TableCell align="right">{commune.rural.total}</TableCell>
                                          <TableCell align="right">{commune.total.masculin}</TableCell>
                                          <TableCell align="right">{commune.total.feminin}</TableCell>
                                          <TableCell align="right">{commune.total.total}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos de la population adulte
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La population adulte (18 ans et plus) représente un indicateur clé pour :
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• L'analyse du marché du travail et de la population active" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• La planification des services sociaux et de santé" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• L'élaboration des politiques électorales" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• La conception de programmes de protection sociale" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données montrent que {keyStats.ruralPercentage}% de la population adulte vit en milieu rural, 
                      avec des disparités importantes entre les sexes ({keyStats.womenPercentage}% de femmes).
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, 
                    de l'Agriculture et de l'Elevage (RGPHAE) réalisé en 2024. La population adulte est définie 
                    comme les personnes âgées de 18 ans ou plus. Les écarts entre les sexes et entre milieux 
                    urbain/rural sont particulièrement analysés pour les politiques publiques ciblées.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer> 
  );
};

export default AdultPopulationPage;